import React from 'react'
import { useTranslation } from 'react-i18next'
import { Fixed } from '../../parts/bases/Fixed'
import { HStack } from '../../parts/bases/HStack'
import { Text } from '../../parts/bases/Text'
import { VStack } from '../../parts/bases/VStack'
import { PinkNeonButton } from '../../parts/buttons/PinkNeonButton'
import { Center } from '../../parts/bases/Center'
import { Absolute } from '../../parts/bases/Absolute'
import IconHelp from '../../../../public/images/iconHelp.png'
import ReactTooltip from 'react-tooltip'
import AmInstallArrow from '@/public/images/amInstallArrow.png'
import Image from 'next/image'

export type Props = {
  akvBalance: number
  amount: string
  walletBalance: string
  inAkiverseBalance: string
  onUpdateAmount: (value: string) => void
  onClickMax: () => void
  onClickWithdraw: () => void
  onClickClose: () => void
  visibleLoading: boolean
}

export const Layout = (props: Props) => {
  const { t } = useTranslation()
  return (
    <Fixed className="top-0 left-0 right-0 bottom-0 z-20 h-full w-full items-center justify-center bg-dialogBg">
      <div className="flex h-full w-full items-center justify-center" onClick={props.onClickClose}>
        <VStack
          className="w-[536px] items-center rounded-xl border-2 border-neon-blue bg-black p-2"
          onClick={(event) => event.stopPropagation()}
        >
          {!props.visibleLoading ? (
            <>
              <VStack className="w-full items-center">
                <Text className="mt-8 text-2xl font-bold text-white">{t('AKVWithdrawDialog.title')}</Text>
                <Text className="mt-8 text-center text-white">{t('AKVWithdrawDialog.description')}</Text>
                <Center className="mt-10">
                  <HStack className="gap-x-1">
                    <Text className="text-white">In AKIVERSE:</Text>
                    <Text className="text-neon-blue">
                      {isNaN(Number(props.inAkiverseBalance)) || Number(props.inAkiverseBalance) === 0
                        ? '0'
                        : Number(props.inAkiverseBalance).toLocaleString()}
                    </Text>
                  </HStack>
                  <Center className="mx-6 h-[8px] w-[10px]">
                    <Image src={AmInstallArrow} width={8} height={10} alt="" />
                  </Center>
                  <HStack className="gap-x-1">
                    <Text className="text-white">In wallet:</Text>
                    <Text className="text-neon-blue">
                      {isNaN(Number(props.walletBalance)) || Number(props.walletBalance) === 0
                        ? '0'
                        : Number(props.walletBalance).toLocaleString()}
                    </Text>
                  </HStack>
                </Center>
                <Center className="mt-4 w-full items-center px-20">
                  <input
                    type="text"
                    inputMode="numeric"
                    className="flex-1 rounded-lg border-2 border-neutral-800 bg-black p-3 pr-28 font-bold text-white caret-neon-blue outline-0 focus:border-neon-blue"
                    onChange={(e) => props.onUpdateAmount(e.target.value)}
                    value={props.amount}
                  />
                  <Absolute className="right-20 pr-1">
                    <PinkNeonButton onClick={props.onClickMax}>MAX</PinkNeonButton>
                  </Absolute>
                </Center>
                <HStack className="mt-8 mb-4">
                  <PinkNeonButton type="Sub" onClick={props.onClickClose}>
                    {t('AKVWithdrawDialog.cancelButton')}
                  </PinkNeonButton>
                  <VStack className="w-4" />
                  <PinkNeonButton
                    onClick={props.onClickWithdraw}
                    disabled={
                      !props.amount || props.amount === '0' || Number(props.amount) > props.akvBalance
                    }
                  >
                    {t('AKVWithdrawDialog.withdrawButton')}
                  </PinkNeonButton>
                </HStack>
                <HStack className="mt-2.5 w-full items-center justify-end">
                  <div data-tip data-for="tooltip" className="flex cursor-pointer flex-row items-center p-2">
                    <Image src={IconHelp} width={20} height={20} layout="fixed" objectFit="contain" alt="" />
                    <span className="ml-2 text-xs text-neutral-400">{t('AKVWithdrawDialog.help')}</span>
                  </div>
                  <ReactTooltip id="tooltip" place="bottom">
                    <div className="w-40 text-xs text-white">{t('AKVWithdrawDialog.helpDetail')}</div>
                  </ReactTooltip>
                </HStack>
              </VStack>
            </>
          ) : (
            <HStack className="m-4 items-center justify-center ">
              <div className="flex justify-center">
                <div className="h-6 w-6 animate-spin rounded-full border-[3px] border-neon-blue border-t-transparent border-opacity-70"></div>
              </div>

              <Text className="ml-4 text-neon-blue">{t('AKVWithdrawDialog.withdrawing')}</Text>
            </HStack>
          )}
        </VStack>
      </div>
    </Fixed>
  )
}
